export function getAppletsUrl(supportLocal: boolean = true) {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  if (supportLocal) {
    if (env === 'localhost') {
      return `${document.location.protocol}://localhost:3010`;
    }
    if (document.location.hostname.startsWith('local.')) {
      return `https://local.getcartwheel.com:3010`;
    }
  }
  return `https://app${env}.getcartwheel.com`;
}

/** `redirectTo` value that lands on the apps dashboard Getting Started tab. */
export const NEW_USER_REDIRECT_TO = 'apps/dashboard?tab=getting-started';

export function getNewUserDashboardUrl(supportLocal: boolean = true) {
  return `${getAppletsUrl(supportLocal)}/dashboard?tab=getting-started`;
}
